import React, { useState, useEffect } from "react";
import { config } from "../config/config";

const MateriaForm = ({ onSubmit, initialData, resetForm }) => {
    const [formData, setFormData] = useState({
        nombre_materia: "",
        grado_id: "",
    });

    const [grados, setGrados] = useState([]); // Estado para almacenar la lista de grados

    // Cargar la lista de grados al montar el componente
    useEffect(() => {
        fetch(`${config.apiUrl}/grados`)
            .then((res) => res.json())
            .then(setGrados)
            .catch(console.error);
    }, []);

    // Actualizar el formulario cuando cambien initialData o resetForm
    useEffect(() => {
        if (initialData) {
            setFormData(initialData);
        } else if (resetForm) {
            setFormData({
                nombre_materia: "",
                grado_id: "",
            });
        }
    }, [initialData, resetForm]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Formulario de Materia</h2>
            <form onSubmit={handleSubmit} className="p-3 border rounded bg-light">
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="nombre_materia" className="form-label">Nombre de la Materia:</label>
                        <input
                            type="text"
                            id="nombre_materia"
                            name="nombre_materia"
                            className="form-control"
                            value={formData.nombre_materia}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label htmlFor="grado_id" className="form-label">Grado:</label>
                        <select
                            id="grado_id"
                            name="grado_id"
                            className="form-control"
                            value={formData.grado_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione un grado</option>
                            {grados.map((grado) => (
                                <option key={grado.grado_id} value={grado.grado_id}>
                                    {grado.nombre_grado}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="text-center">
                    <button type="submit" className="btn btn-primary">Guardar</button>
                </div>
            </form>
        </div>);
};

export default MateriaForm;